import { useQuery } from '@tanstack/react-query';
import { profileApi } from '~/lib/request';
import { SocialMediaAccount, User } from './types';

function useCurrentUser() {
  // TODO: switch to useQueries
  const result = useQuery({
    queryKey: ['currentUser'],
    queryFn: () =>
      Promise.all([
        profileApi.get('api/profile/me').json<User>(),
        profileApi.get('api/profile/me/avatar').text(),
        profileApi.get('api/profile/me/social-media-accounts').json<SocialMediaAccount[] | null>(),
      ]).then(([user, avatar, socialMediaAccount]) => ({ ...user, avatar, socialMediaAccount })),
    throwOnError: true,
  });

  return result.data;
}

export default useCurrentUser;
